import { analytics } from 'segment_analytics'
import { useDeeplinkModal } from 'components/app_deep_link_modal'
import { OnClickShareCtaProps } from './types'
import { OpenDeeplinkModalProps } from 'components/app_deep_link_modal/types'
import { useDeviceDetect } from '@fable/hooks'
import { handleDeeplink } from 'utils'

export const useShareObject = () => {
  const { isMobile } = useDeviceDetect()
  const { openDeeplinkModal } = useDeeplinkModal()

  const onClickCta = ({
    id,
    type,
    cta,
    deepLink,
    ...props
  }: OnClickShareCtaProps) => {
    const eventMetadata = {
      share_object_id: id,
      share_object_type: type,
      share_object_cta: cta,
    }

    analytics.events.shareObjectCtaClicked(eventMetadata)

    if (isMobile && !!deepLink?.length) {
      handleDeeplink(deepLink)
      return
    }

    const modalProps: OpenDeeplinkModalProps = {
      eventMetadata,
      hideSMS: true,
      ...props,
    }

    if (!!deepLink?.length) modalProps.link = deepLink

    openDeeplinkModal(modalProps)
  }

  return { onClickCta }
}
